"use client";

import { Card, CardContent } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface MetricCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  trend?: string;
  trendColor?: string;
  icon: LucideIcon;
  iconBgColor: string;
  iconColor: string;
}

export function MetricCard({
  title,
  value,
  subtitle,
  trend,
  trendColor = "text-emerald-600",
  icon: Icon,
  iconBgColor,
  iconColor,
}: MetricCardProps) {
  return (
    <Card className="border-0 shadow-sm">
      <CardContent className="">
        <div className="flex items-start justify-between ">
          <div className="space-y-7">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <div>
              <div className="flex items-baseline gap-2 mt-2">
                <h3 className="text-2xl font-semibold">{value}</h3>
                {trend && (
                  <span className={`text-xs ${trendColor} font-medium`}>
                    {trend}
                  </span>
                )}
              </div>
              {subtitle && (
                <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
              )}
            </div>
          </div>
          <div
            className={`h-10 w-10 rounded-full ${iconBgColor} flex items-center justify-center`}
          >
            <Icon className={`h-5 w-5 ${iconColor}`} />
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
